// src/sync/initArtifactHydration.ts

/**
 * Artifact Hydration Bootstrap - auto-loads a project's strategic memory on open.
 *
 * Subscribes to the project store's "state:loaded" event (emitted whenever a
 * project is opened) and hydrates the artifact store for that project. This is
 * what makes Nuvra's reasoning follow the user across reloads and devices: open
 * a product anywhere and its blueprint, discovery, and recommendations are there.
 *
 * Decoupled by design (event-driven), so no contested workspace/UI file is
 * touched. Idempotent: repeated init calls register a single subscription.
 */

import { eventBus } from "@/runtime/eventBus";
import { useProjectArtifactStore } from "@/store/projectArtifactStore";
import { logger } from "@/system/logger";

let unsubscribe: (() => void) | null = null;

export function initArtifactHydration(): boolean {
  if (unsubscribe) return true;

  unsubscribe = eventBus.on("state:loaded", (event) => {
    const projectId = event.projectId;
    if (!projectId) return;
    void useProjectArtifactStore.getState().hydrate(projectId);
  });

  logger.info("[initArtifactHydration] Strategic-artifact hydration wired");
  return true;
}

/** Test/teardown helper. */
export function _resetArtifactHydrationForTest(): void {
  if (unsubscribe) { unsubscribe(); unsubscribe = null; }
}
